<template>
    <div class="d-flex align-items-center py-5">
        <div id="inner_404" class="text-center mx-auto p-2">
            <h1>404</h1>
            <h2 class="my-4 headline">Sorry, page not found</h2>
            <div class="mt-5">
                <b-button variant="primary" class="mr-2" @click="goBack">Take me back!</b-button>
                <b-button variant="outline" @click="goHome">Go Home</b-button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        methods: {
            goBack () {
                this.$router.go(-1);
            },
            goHome () {
                this.$router.push({path: '/'})
            }
        }
    }
</script>
<style scoped>
    h1 {
        font-size: 10em;
        line-height: 1em;
        font-weight: 700;
        color: #252932;
        text-shadow: rgba(61, 61, 61, 0.3) 1px 1px, rgba(61, 61, 61, 0.2) 2px 2px, rgba(61, 61, 61, 0.3) 3px 3px;
    }

    div.inner_404 {
        width: 100%;
        max-width: 330px;
    }
</style>
